import cts from '../app/cts';
import apis from '../app/apis';

const getCollection = async (projectId, districtId, zone, lang) => {
  try {
    const { data, status } = await cts('get', apis.getCollectionJson(projectId, districtId, zone, lang));

    if (
      !data
      || status !== 200
    ) throw new Error('Error getting collection details');

    return Promise.resolve(data.collection.types);
  } catch ({ message }) {
    return Promise.reject(message);
  }
};

export default getCollection;
